<div class="CommonContainerCard border__radius8 CommonBorderColor containerMtop">
    <div class="sub-heading-s1 fleet-section-title reviewTxt">Review</div>
    <div class="single-line"></div>
    <ul class="review-basic-info">
       
            <p class="basicInfoColor body-b2 fw-700 m-bottom">Basic information</p>
            <li>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Ship / Code</p>
                    <p class="body-b2 fleet-section-title fw-700">{{shipName}} / {{shipCode}}</p>
                </div>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Pool</p>
                    <p class="body-b2 fleet-section-title fw-700">Pool {{shipPoool}}</p>
                </div>
            </li>
            <li>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Ship owner</p>
                    <p class="body-b2 fleet-section-title fw-700">{{shipOwner}}</p>
                </div>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Class</p>
                    <p class="body-b2 fleet-section-title fw-700">{{shipClass}}</p>
                </div>
            </li>
            <li>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Status</p>
                    <p class="body-b2 fleet-section-title fw-700">{{dateStatus !== true ? 'Active' : 'Pending' }}</p>
                </div>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Status effective from</p>
                    <p class="body-b2 fleet-section-title fw-700">{{effectiveDate | date:'dd MMM yyyy'}}</p>
                </div>
            </li>
   
    </ul>
    <div class="single-line"></div>
    <ul class="review-basic-info">
        <li>
            <div class="colWidthHeight">
                <p class="body-b fleet-body-b3">Is scrubber in use?</p>
                <p class="body-b2 fleet-section-title fw-700">{{isScrubber === true ? 'Yes' : 'No' }}</p>
            </div>
            <div class="colWidthHeight">
                <p class="body-b fleet-body-b3">Is LNG in use?</p>
                <p class="body-b2 fleet-section-title fw-700">{{isLng === true ? 'Yes' : 'No'  }}</p>
            </div>
        </li>
    </ul>
    <div class="single-line"></div>
    <ul class="review-basic-info">
            <p class="body-b2 basicInfoColor m-bottom fw-700">Points</p>
            <li>
                <div class="colWidthHeight">
                    <p class="body-b fleet-body-b3">Pool points</p>
                    <p class="body-b2 fleet-section-title fw-700">{{poolPoints}}</p>
                </div>
                <div class="colWidthHeight" *ngIf="isScrubber">
                    <p class="body-b fleet-body-b3">Scrubber points</p>
                    <p class="body-b2 fleet-section-title fw-700">{{scrubberPoints}}</p>
                </div>
            </li>
    </ul>
</div>